import { FormEvent, FormEventHandler, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import { useSearchAuftraegeMutation } from '../../api/AuftragAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import PaginatorComponent from '../eigeneauftraege/component/PaginatorComponent';
import { PaginatorDto } from '../eigeneauftraege/EigeneAuftraegeListe';
import { useGetAuftragTableOrderServiceMutation } from '../../api/ProfileAPI';

/**
 * @author noone
 */
export default function AuftragSearch() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const [searchAuftragAPI] = useSearchAuftraegeMutation();
    const [getProfileParameter] = useGetAuftragTableOrderServiceMutation();

    const [sortBy, setSortBy] = useState<string>("");
    const [offset, setOffset] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [sortDirection, setSortDirection] = useState<string>("");
    const [suchFeld, setSuchFeld] = useState<string>("");

    const [auftragslisteGesamt, setAuftragslisteGesamt] = useState<PaginatorDto>({ offset: 0, limit: 10, totalCount: 0, data: [] });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const sort = (column: string) => {

        if (sortBy !== column) {
            setSortDirection("asc");
        } else if (sortDirection === "") {
            setSortDirection("asc");
        } else if (sortDirection === "asc") {
            setSortDirection("desc");
        } else if (sortDirection === "desc") {
            setSortDirection("");
        }

        setSortBy(column);
    }

    const getIconBySort = (column: string) => {
        if (column !== sortBy) {
            return "bi bi-arrow-down-up";
        } else if (sortDirection === "asc") {
            return "bi bi-arrow-up";
        } else if (sortDirection === "desc") {
            return "bi bi-arrow-down";
        } return "bi bi-arrow-down-up";
    }

    const suche = () => {

        setIsLoading(true);

        searchAuftragAPI({
            offset: offset,
            limit: limit,
            search: suchFeld,
            sortBy: sortBy,
            sortDirection: sortDirection
        }).unwrap()
            .then(data => setAuftragslisteGesamt(data))
            .catch((error) => console.log(error))
            .finally(() => {
                setIsLoading(false);
            })
            ;
    }

    const pageChangeHandler = (page: number) => {
        setOffset(page * limit - limit);
    }

    const submitHandle = (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        setOffset(0);
        suche();
    }

    const getFarbeZuStatus = (status: string) => {
        if (status === "NEU") {
            return "lightblue";
        } else if (status === "IN_TERMINIERUNG") {
            return "lightblue";
        } else if (status === "IN_TERMINIERUNG") {
            return "yellow";
        } else if (status === "FERTIG") {
            return "lightgreen";
        } else
            return "white";
    }

    useEffect(() => {
        getProfileParameter("auftragsearch").unwrap().then((dto) => {
            var intDirection: number = 0;
            let columnToSort = "";

            if (dto.art !== 0) {
                columnToSort = "art";
                intDirection = dto.art;
            }
            if (dto.status !== 0) {
                columnToSort = "status";
                intDirection = dto.status;
            }
            if (dto.auftragsnr !== 0) {
                columnToSort = "auftragnr";
                intDirection = dto.auftragnr;
            }
            if (dto.name !== 0) {
                columnToSort = "name";
                intDirection = dto.name;
            }
            if (dto.lieferort !== 0) {
                columnToSort = "lieferort";
                intDirection = dto.lieferort;
            }
            if (dto.termin !== 0) {
                columnToSort = "termin";
                intDirection = dto.termin;
            }
            if (dto.erstellt_am !== 0) {
                columnToSort = "erstellt_am";
                intDirection = dto.erstellt_am;
            }

            setSortBy(columnToSort);
            if (intDirection === 1) {
                setSortDirection("asc");
            } else if (intDirection === -1) {
                setSortDirection("desc");
            }
        }).catch((error) => {
            console.log(error);
            setSortBy("");
            setSortDirection("");
        });

    }, [searchAuftragAPI]);

    useEffect(() => {
        // window.scrollTo(0, 0);
        suche();
    }, [sortBy, sortDirection, offset]);

    return (
        <>
            <LoadingModal show={isLoading} />

            <div>

                <LandingpageHeader />

                <div style={{ padding: "20px" }}>

                    <button
                        onClick={() => {
                            navigate({
                                pathname: "/",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                    </button>

                    <h4 style={{ textAlign: "center" }}>Auftragssuche</h4>

                    <form onSubmit={submitHandle} >
                        Suche:
                        <input type="text" className='form-control' placeholder='Suche' value={suchFeld} onChange={(e) => setSuchFeld(e.target.value)} />
                        <button type="submit" className='btn btn-primary' style={{ marginTop: "10px" }}>Suchen</button>
                    </form>

                    <PaginatorComponent offset={offset} limit={limit} totalCount={auftragslisteGesamt.totalCount} pageChange={pageChangeHandler} />

                    <div style={{ marginTop: "40px" }}>
                        {auftragslisteGesamt?.totalCount === 0 && <div>Keine Aufträge vorhanden</div>}
                        {auftragslisteGesamt?.totalCount === 1 && <div>Insgesamt {auftragslisteGesamt?.totalCount} Auftrag vorhanden</div>}
                        {auftragslisteGesamt?.totalCount > 1 && <div>Insgesamt {auftragslisteGesamt?.totalCount} Aufträge vorhanden</div>}
                    </div>

                    <table className="table" style={{ width: "100%", marginTop: "20px" }}>
                        <thead>
                            <tr>
                                <th onClick={() => { sort("status") }} scope="col"><span translate="no">Status</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("status")} /></th>
                                <th onClick={() => { sort("art") }} scope="col"><span translate="no">Art</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("art")} /></th>
                                <th onClick={() => { sort("auftraggeber") }} scope="col"><span translate="no">Auftraggeber</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("auftraggeber")} /></th>
                                <th onClick={() => { sort("bearbeiter") }} scope="col"><span translate="no">Bearbeiter</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("bearbeiter")} /></th>
                                <th onClick={() => { sort("name") }} scope="col"><span translate="no">Name</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("name")} /></th>
                                <th onClick={() => { sort("strasse") }} scope="col"><span translate="no">Strasse</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("strasse")} /></th>
                                <th onClick={() => { sort("ort") }} scope="col"><span translate="no">Ort</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("ort")} /></th>
                                <th onClick={() => { sort("email") }} scope="col"><span translate="no">Email</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("email")} /></th>
                                <th onClick={() => { sort("termin") }} scope="col"><span translate="no">Termin</span> <i style={{ marginLeft: "10px" }} className={getIconBySort("termin")} /></th>
                                <th>Aktionen</th>
                            </tr>
                        </thead>
                        <tbody>
                            {auftragslisteGesamt?.data?.map((auftrag, index) => (
                                <tr key={index}>
                                    <td style={{ padding: "12px 16px" }}><label style={{ borderRadius: "10px", border: "none", padding: "10px", backgroundColor: getFarbeZuStatus(auftrag.status) }}>{auftrag.status}</label></td>
                                    <td>{auftrag.art}</td>
                                    <td>{auftrag.auftraggeber.name}</td>
                                    <td>{auftrag.bearbeiter?.name}</td>
                                    <td>{auftrag.vorname_endkunde} {auftrag.name_endkunde}</td>
                                    <td>{auftrag.strasse_lieferadresse} {auftrag.hausnummer_lieferadresse}</td>
                                    <td>{auftrag.stadt_lieferadresse}</td>
                                    <td>{auftrag.email_lieferadresse}</td>
                                    <td>{formatToEuroDateTime(auftrag.aktuellerTermin)}</td>
                                    <td>
                                        <button
                                            className="btn btn-primary"
                                            onClick={(event: FormEvent) => {
                                                event.stopPropagation();
                                                window.open(
                                                    "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                                                    "_blank"
                                                );
                                            }} ><i className='bi bi-pencil-fill'></i></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <PaginatorComponent offset={offset} limit={limit} totalCount={auftragslisteGesamt.totalCount} pageChange={pageChangeHandler} />

                </div >

                <Footer />

            </div >
        </>
    );

}

